import axios from 'axios'

export const getAppInfo = async () => {
  try {
    const response = await axios.get("/api/shop/shopify/appInfo");
    return response.data;
  } catch (err) {
    console.log("err", err)
  }
}